define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ProjectManagerModel = /** @class */ (function () {
        function ProjectManagerModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ProjectManagerModel.Mapping, self);
            }
        }
        ProjectManagerModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ProjectManagerModel(options.data);
            }
        };
        return ProjectManagerModel;
    }());
    return ProjectManagerModel;
});
//# sourceMappingURL=ProjectManagerModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ProjectManagerModel.js
// module id = 231
// module chunks = 2